export const emptyChargeDetail = {
    "status": 200,
    "data": {
        "charge": {
            "name": "Nuevo cobro"
        },
        "recurrence": {
            "columns": [
                {
                    "dataIndex": "frequency_type",
                    "key": "frequency_type",
                    "title": "Recurrencia"
                },
                {
                    "dataIndex": "issue_date",
                    "key": "issue_date",
                    "title": "Emisión de cobro"
                },
                {
                    "dataIndex": "due_date",
                    "key": "due_date",
                    "title": "Vencimiento de cobro"
                }
            ],
            "dataSource": [],
            "message": "Aún no se ha definido una recurrencia",
            "metadata": null
        },
        "late_fee": {
            "message": "Aún no se ha definido mora",
            "formated_data": null,
            "metadata": {
                "enabled": false,
                "charge_late_fee_type_id": null,
                "value": null
            }
        }
    },
    "metadata": null,
    "errors": null
}